import type { NmoUserApiResponse } from '@candyland/generic/shared/model-nmo';
import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import * as fromAuth from './auth-v2.actions';
import type { HttpErrorResponse } from '@angular/common/http';

export const AUTH_FEATURE_KEY_V2 = 'auth';

export interface AuthStateV2 {
  error?: HttpErrorResponse;
  userData: NmoUserApiResponse | null;
  isLoggedIn: boolean | null;
}

export interface AuthPartialStateV2 {
  readonly [AUTH_FEATURE_KEY_V2]: AuthStateV2;
}

const _authReducer = createReducer(
  void 0,
  on(fromAuth.initialLoginCheckV2.notLoggedIn, () => ({ userData: null, isLoggedIn: false })),
  on(fromAuth.initialLoginCheckV2.loggedIn, () => ({
    userData: null,
    isLoggedIn: true,
  })),
  on(fromAuth.usersApiV2.loadUserDataSuccess, (state, { userData }) => ({
    ...state,
    userData,
    isLoggedIn: true,
    error: null,
  })),
  on(fromAuth.usersApiV2.loadUserDataFailure, (state, { error }: { error: HttpErrorResponse }) => ({
    ...state,
    error,
  })),
  on(fromAuth.usersApiV2.loginCheckWasPositive, (_, { userData }) => ({
    userData,
    isLoggedIn: true,
  })),
  on(fromAuth.usersApiV2.loginCheckWasNegative, fromAuth.removeUserFromStoreV2, () => ({
    userData: null,
    isLoggedIn: false,
  })),
  on(fromAuth.usersApiV2.loginCheckError, (state, { error }: { error: HttpErrorResponse }) => ({ ...state, error }))
);

export function authReducerV2(state: AuthStateV2, action: Action): AuthStateV2 {
  return _authReducer(state, action);
}
